import React, { useContext, useMemo } from 'react';

import { assocPath } from 'ramda';

import { BlockContextProvider, IBlockContext } from '../../../../LandingV2/Page/RightSide/Block/context';
import { IBlockConfig } from '../../../../LandingV2/Page/RightSide/blocks/types';
import { PAGE_TYPES_WITH_IMAGES } from '../../../constants';
import { PDFDataContext } from '../../../context';
import Image from '../../shared/Image';
import Title from '../../shared/Title';
import { getBlockConfig } from './config';

// @ts-ignore TODO block types
function Blocks({ items }) {
  // @ts-ignore
  return items.map((b, i) => {
    if (!b) {
      return null;
    }
    return (
      <React.Fragment key={i}>
        <PDFBlock items={items} block={b} index={i} />
      </React.Fragment>
    );
  });
}

export default Blocks;

// @ts-ignore
function PDFBlock({ items, block, index }) {
  const { showImages } = useContext(PDFDataContext);

  const value = useMemo<IBlockContext>(() => {
    if (block.type === 'textbox') {
      return {
        block: assocPath(['meta', 'indent'], true, block),
        index: [0],
        config: {} as IBlockConfig,
      };
    }

    return {
      block,
      index: [0],
      config: {} as IBlockConfig,
    };
  }, [block]);

  const { Component } = getBlockConfig({ type: block.type });

  if (!Component) {
    return null;
  }

  const isNewPage = items[index - 1] && items[index - 1].pageTitle !== block.pageTitle;
  const showImage = showImages && PAGE_TYPES_WITH_IMAGES.includes(block.pageType);

  return (
    <>
      {isNewPage && (
        <div style={{ marginTop: 50 }}>
          <Title text={block.pageTitle} withBorder={block.type !== 'header'} />
          {showImage && block.image && <Image url={block.image} focalPointCoords={block.primaryImageCoords} />}
        </div>
      )}
      <BlockContextProvider value={value}>
        <Component block={block} />
      </BlockContextProvider>
    </>
  );
}
